import type { CanceledOrderMiniEntity } from './CanceledOrderMiniEntity'

export class CanceledOrderResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<CanceledOrderMiniEntity> | null
}
